import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Cancel } from '@mui/icons-material'

type OnGoingProjectActionsMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onCancelQaAction: (id: string) => void
}

export const OnGoingProjectActionsMenu: React.FC<OnGoingProjectActionsMenuProps> = ({
    anchorEl,
    onClose,
    onCancelQaAction,
    id,
}) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onCancelQaAction(id!)}>
                    <ListItemIcon>
                        <Cancel />
                    </ListItemIcon>
                    <ListItemText primary={t('common.cancelQa')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
